import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import FeatureTogglesPage from './pages/FeatureTogglesPage';
import MinAppVersionPage from './pages/MinAppVersionPage';
import MaintenanceModePage from './pages/MaintenanceModePage';
import SettingsPage from './pages/SettingsPage';
import ScheduledJobsPage from './pages/ScheduledJobsPage';
import PlayerRewardsPage from './pages/PlayerRewardsPage';
import CreatePlayerPage from './pages/CreatePlayerPage';
import GroupsPage from './pages/GroupsPage';
import CoachesPage from './pages/CoachesPage';
import PlayersPage from './pages/PlayersPage';
import ParentsPage from './pages/ParentsPage';
import CoachSalaryPage from './pages/CoachSalaryPage';
import RewardsCatalogPage from './pages/RewardsCatalogPage';
import MonthlyWinnersPage from './pages/MonthlyWinnersPage';
import TrainingsPage from './pages/TrainingsPage';
import GymDutiesPage from './pages/GymDutiesPage';
import NormativesPage from './pages/NormativesPage';
import PlacesPage from './pages/PlacesPage';
import InvoicesPage from './pages/InvoicesPage';
import PaymentSchedulePage from './pages/PaymentSchedulePage';
import FeesPage from './pages/FeesPage';
import ChatsPage from './pages/ChatsPage';
import './App.css';

function RequireAuth({ children }: { children: React.ReactElement }) {
  const token = localStorage.getItem('admin_token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route path="/" element={<Navigate to="/feature-toggles" replace />} />
          <Route path="/feature-toggles" element={<FeatureTogglesPage />} />
          <Route path="/min-app-version" element={<MinAppVersionPage />} />
          <Route path="/maintenance-mode" element={<MaintenanceModePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/scheduled-jobs" element={<ScheduledJobsPage />} />
          <Route path="/player-rewards" element={<PlayerRewardsPage />} />
          <Route path="/players/new" element={<CreatePlayerPage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/coaches" element={<CoachesPage />} />
          <Route path="/players" element={<PlayersPage />} />
          <Route path="/parents" element={<ParentsPage />} />
          <Route path="/coach-salary" element={<CoachSalaryPage />} />
          <Route path="/rewards" element={<RewardsCatalogPage />} />
          <Route path="/monthly-winners" element={<MonthlyWinnersPage />} />
          <Route path="/trainings" element={<TrainingsPage />} />
          <Route path="/gym-duties" element={<GymDutiesPage />} />
          <Route path="/normatives" element={<NormativesPage />} />
          <Route path="/places" element={<PlacesPage />} />
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/payment-schedule" element={<PaymentSchedulePage />} />
          <Route path="/fees" element={<FeesPage />} />
          <Route path="/chats" element={<ChatsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
